module.exports = __webpack_public_path__ + "static/img/shui3.9838ace.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/shui3.png
// module id = vW/Q
// module chunks = 44